/* ARIELLE v38 – Color variants change the Teddy model image only when a color is chosen.
   Thumbnails and arrows stay within the selected color, without altering other products. */
(function(){
  function selectedColor(){
    var group=document.querySelector('[data-ar38-teddy-gallery] ~ .ar-product-v10__details [data-ar-option-name="Farbe"]');
    if(!group)group=document.querySelector('.ar-product-v10__details [data-ar-option-name="Farbe"]');
    if(!group)return 'Rosa';
    var choice=group.querySelector('[data-ar-choice].is-selected');
    return choice?choice.getAttribute('data-ar-option-value'):'Rosa';
  }
  function sync(color){
    var gallery=document.querySelector('[data-ar38-teddy-gallery]');
    if(!gallery)return;
    var thumbs=Array.prototype.slice.call(gallery.querySelectorAll('[data-ar-thumb]'));
    var visible=[];
    thumbs.forEach(function(thumb){
      var matches=thumb.getAttribute('data-ar38-color')===color;
      thumb.hidden=!matches;
      if(matches)visible.push(thumb);
    });
    if(!visible.length)return;
    var first=visible[0],hero=gallery.querySelector('.ar-product-v10__hero-image');
    if(hero){
      hero.src=first.getAttribute('data-image-src');
      hero.removeAttribute('srcset');
      hero.removeAttribute('sizes');
      hero.alt=first.getAttribute('data-image-alt')||'ARIELLE Teddy-Struktur Lounge-Set – '+color;
    }
    thumbs.forEach(function(thumb){
      var active=thumb===first;
      thumb.classList.toggle('is-active',active);
      thumb.setAttribute('aria-pressed',active?'true':'false');
    });
    gallery.setAttribute('data-ar38-selected-color',color);
  }
  function initialize(){
    if(!document.querySelector('[data-ar38-teddy-gallery]'))return;
    sync(selectedColor());
    document.addEventListener('click',function(event){
      var choice=event.target.closest('[data-ar-choice]');
      if(!choice)return;
      var group=choice.closest('[data-ar-option-group]');
      if(!group||!/^(farbe|color|colour)$/i.test(group.getAttribute('data-ar-option-name')||''))return;
      var color=choice.getAttribute('data-ar-option-value');
      if(color)requestAnimationFrame(function(){sync(color);});
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initialize);
  else initialize();
})();